<template>

<div class="vx-card p-6">

  <vx-card card-border class="mb-4" title="Datos identificativos de la empresa" title-color="dark" collapseAction>
    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span>C.I.F.</span>
        </div>
        <div>
          <vs-input disabled class="w-full" name="cif" v-model="empresa.cif"/>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span>Nombre o razón social</span>
        </div>
        <div>
          <vs-input disabled class="w-full" name="nombre" v-model="empresa.nombre"/>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <span>Teléfono</span>
        </div>
        <div>
          <vs-input disabled name="telefono" class="w-full" v-model="empresa.telefono" />
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <span>E-mail</span>
        </div>
        <div>
          <vs-input disabled name="email" class="w-full" v-model="empresa.email" />
        </div>
      </div>
    </div>
  </vx-card>

  <vx-card card-border class="mb-6" title="Datos del responsable" title-color="dark" collapseAction>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div>
          <span>Nombre y apellidos del responsable de la empresa</span>
        </div>
        <div>
          <vs-input class="w-full" data-vv-as="RESPONSABLE" v-validate="'required'" name="responsable" v-model="empresa.responsable" 
            disabled />
          <span class="text-danger text-sm"  v-show="errors.has('responsable')">{{ errors.first('responsable') }}</span>
        </div>
      </div>
    </div>
  </vx-card>

  <vx-card card-border class="mb-6" title="Otros datos de la empresa" title-color="dark" collapseAction>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div>
          <span>Web</span>
        </div>
        <div>
          <vs-input disabled name="web" class="w-full" v-model="empresa.web" />
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div class="vx-col w-full mb-3">
          <span>Empresa inactiva/activa</span>
        </div>
        <div class="vx-col w-full">
          <vs-switch disabled vs-type="success" v-model="empresa.activa"/>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full">
        <div>
          <span>Descripción</span>
        </div>
        <div>
          <vs-textarea disabled name="descripcion" v-model="empresa.descripcion" />
        </div>
      </div>
    </div>
  </vx-card>

  <div class="vx-row" id="account-manage-buttons">
      <div class="vx-col sm:w-1/2 flex w-full">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{ name: 'empresasEditar', params: { empresaId: $route.params.empresaId }}">Editar</vs-button>
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Borrar</vs-button>
      </div>
      <div class="vx-col sm:w-1/2 flex w-full justify-end">
          <vs-button color="warning" type="border" :to="{ name: 'empresas' }">Cancelar</vs-button>
      </div>
  </div>
</div>

</template>

<script>
// Store Module
import empresasStore from '@/store/configuracion/empresas/index.js'

export default {
  components: {
  },
  data () {
    return {
      empresa: {
        cif: null,
        nombre: null,
        telefono: null,
        email: null,
        responsable: null,
        web: null,
        activa: false,
        descripcion: null,
        logo: null
      }
    }
  },
  computed: {
  },
  methods:{
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar la empresa "${this.empresa.nombre}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('empresasStore/deleteEmpresa', this.empresa.id)
        .then(()   => { 
          this.showDeleteSuccess()
          this.$router.push({ name: 'empresas' })
        })
        .catch(error => { this.showDeleteError(error) })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Registro eliminado',
        text: 'La empresa ha sido eliminada correctamente'
      })
    },
    showDeleteError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error eliminando la empresa',
        text: error
      })
    }
  },
  created () {
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }

    const empresaId = this.$route.params.empresaId
    const idx = this.$store.state.empresasStore.empresas.findIndex((u) => u.id == empresaId)
    this.empresa = this.$store.state.empresasStore.empresas[idx]
  }
}
</script>